/* WAVY-JADE-0926 (W3): quick add.
   Delegated click on [data-wj-qa] (W1 renders it on jade cards, value = product url) -> fetch
   url + '?view=wavy-qv' (templates/product.wavy-qv.liquid, layout none) -> inject into a shell built once
   on <body>: desktop centred card modal, <=749px bottom sheet. Choose-first options (contract 4),
   two-line ATC (contract 5), money via window.wjMoney (contract 1) with an inline Shopify-format
   fallback, size guide via window.wjSizeGuide (contract 2, trigger hidden when absent).
   Add = ONE POST /cart/add.js {items, sections, sections_url} -> close -> cart-drawer.renderContents
   (same handoff as product-form.js: is-empty off, cartUpdate published) -> 'wj:qa-added'.
   Motion: forced reflow before .is-in, never rAF; exits time out at 240ms; reduced motion = 0ms.
   The pure core (resolve/formatMoney/labels) hangs off window.wjQuickAdd.core for the node harness.
   No Liquid in here: every product fact comes from the fragment's JSON. */
(function () {
  'use strict';
  if (window.wjQuickAdd) return;

  var VIEW = 'wavy-qv';
  var MAX_QTY = 10;
  var EXIT_MS = 240;
  var cache = Object.create(null);
  var prefetching = Object.create(null);
  var shell = null, panel = null, body = null;
  var isOpen = false, closing = false, trigger = null, currentKey = '', bodyPad = '';
  var ctx = null;

  /* ---------------------------------------------------------------- helpers */
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function reduced() { return mq('(prefers-reduced-motion: reduce)'); }
  function normalize(url) { return String(url).split('#')[0]; }
  function withView(key) { return key + (key.indexOf('?') > -1 ? '&' : '?') + 'view=' + VIEW; }
  function isFragment(txt) { return typeof txt === 'string' && txt.indexOf('data-wj-qv-json') > -1; }

  /* ------------------------------------------------------------ pure core */
  /* Port of Shopify.formatMoney; tags stripped so textContent writes stay clean. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var fmt = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      var s = (n / 100).toFixed(precision);
      var parts = s.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelims(cents, 2, ' ', '.'); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return fmt.replace(re, value).replace(/<[^>]*>/g, '').trim();
  }

  function money(cents, data) {
    if (window.wjMoney && typeof window.wjMoney.format === 'function') {
      try { return window.wjMoney.format(cents); } catch (e) { /* fall through */ }
    }
    var fmt = (window.wjMoneyCfg && window.wjMoneyCfg.format) || (data && data.moneyFormat) || '${{amount}}';
    return formatMoney(cents, fmt);
  }

  /* Contract 4 copy: window.wjBogo.selectLabel (W2) when present so both surfaces print the same string; the
     fallback is the same rule ("Clasp (Sterling Silver)" -> "clasp", "Chain Styles" -> "chain style", never "ss"). */
  function optionLabel(name) {
    var n = String(name || 'option').replace(/\s*\(.*$/, '').trim().toLowerCase();
    if (n.length > 3 && /s$/.test(n) && !/ss$/.test(n)) n = n.slice(0, -1);
    return n;
  }
  function selectLabel(name) {
    if (window.wjBogo && typeof window.wjBogo.selectLabel === 'function') {
      try { return window.wjBogo.selectLabel(name); } catch (e) { /* fall through */ }
    }
    var n = optionLabel(name);
    return 'Select ' + (/^[aeiou]/.test(n) ? 'an ' : 'a ') + n;
  }
  /* Jade unit prices already in the cart (presentment cents), from the drawer meter W2 renders (data-wj-prices). */
  function cartUnits() {
    var drawer = document.querySelector('cart-drawer');
    var m = drawer && drawer.querySelector('[data-wj-meter]');
    return String((m && m.getAttribute('data-wj-prices')) || '').split(',').map(Number).filter(function (n) { return n > 0; });
  }
  function quoteFn() {
    return (window.wjBogo && typeof window.wjBogo.quote === 'function') ? window.wjBogo.quote : null;
  }
  function savePct(compare, price) {
    return compare > price && compare > 0 ? Math.floor((compare - price) * 100 / compare) : 0;
  }
  function matches(v, sel, skip) {
    for (var i = 0; i < sel.length; i++) {
      if (i === skip || sel[i] == null) continue;
      if (v.options[i] !== sel[i]) return false;
    }
    return true;
  }

  /* One function decides everything the UI shows for a selection + quantity.
     units = jade unit prices already in the cart, quote = wjBogo.quote (server BXGY maths: the cheaper half of
     all jade units lose half). save > 0: the button strikes the sell total and shows the real pay ('pair').
     save < 0 (even cart, this piece cheaper: the 50% moves onto it and the cart rises by MORE than its price):
     now = the real cart increase, struck = sell x qty, plus a note ('shift'). save == 0 or no wjBogo:
     compare-at x qty -> sell x qty ('single'). Never a number the cart will not charge. */
  function resolve(data, sel, qty, units, quote) {
    var opts = data.options || [], vars = data.variants || [];
    var pending = [], i;
    for (i = 0; i < opts.length; i++) {
      if (opts[i].values.length > 1 && sel[i] == null) pending.push(opts[i].name);
    }
    var cands = vars.filter(function (v) { return matches(v, sel, -1); });
    var availC = cands.filter(function (v) { return v.available; });
    var pool = availC.length ? availC : cands;
    var lo = null;
    pool.forEach(function (v) { if (!lo || v.price < lo.price) lo = v; });
    var varies = false;
    if (pool.length > 1) {
      var p0 = pool[0].price;
      varies = pool.some(function (v) { return v.price !== p0; });
    }
    var variant = pending.length ? null : (cands[0] || null);
    var values = opts.map(function (o, oi) {
      return o.values.map(function (val) {
        var any = false, avail = false;
        for (var k = 0; k < vars.length; k++) {
          var v = vars[k];
          if (v.options[oi] !== val || !matches(v, sel, oi)) continue;
          any = true;
          if (v.available) { avail = true; break; }
        }
        return avail ? 'ok' : (any ? 'off' : 'none');
      });
    });
    var state = pending.length ? 'pending' : (!variant ? 'unavailable' : (!variant.available ? 'soldout' : 'ready'));
    var max = MAX_QTY;
    if (variant && variant.max > 0) max = Math.min(MAX_QTY, variant.max);
    var wanted = Math.max(1, qty || 1);
    var q = Math.min(wanted, max);
    var price = lo ? lo.price : 0, compare = lo ? (lo.compare || 0) : 0;
    if (variant) { price = variant.price; compare = variant.compare || 0; varies = false; }
    var image = -1;
    if (variant) image = variant.image;
    else if (pool.length && pool.every(function (v) { return v.image === pool[0].image; })) image = pool[0].image;
    var total = price * q, totalStrike = compare > price ? compare * q : 0, saving = 0, mode = 'single';
    if (state === 'ready' && typeof quote === 'function') {
      var add = [];
      for (i = 0; i < q; i++) add.push(price);
      var qq = null;
      try { qq = quote(units || [], add); } catch (e) { qq = null; }
      if (qq && qq.save > 0 && qq.pay >= 0) { mode = 'pair'; total = qq.pay; totalStrike = qq.strike; saving = qq.save; }
      else if (qq && qq.save < 0) { mode = 'shift'; total = qq.pay; totalStrike = qq.strike; saving = qq.save; }
    }
    return {
      state: state,
      pending: pending,
      variant: variant,
      values: values,
      price: price,
      compare: compare,
      save: savePct(compare, price),
      from: varies,
      qty: q,
      clamped: q < wanted,
      max: max,
      stockCapped: !!(variant && variant.max > 0 && variant.max < MAX_QTY),
      mode: mode,
      total: total,
      totalStrike: totalStrike,
      saving: saving,
      image: image
    };
  }

  /* ------------------------------------------------------------ shell */
  function skeleton() {
    return '<div class="wj-qv wj-qv--skel" aria-busy="true" aria-label="Loading">'
      + '<div class="wj-qv__media"><div class="wj-qv__sk wj-qv__sk--img"></div></div>'
      + '<div class="wj-qv__info"><div class="wj-qv__sk wj-qv__sk--h"></div><div class="wj-qv__sk wj-qv__sk--l"></div>'
      + '<div class="wj-qv__sk wj-qv__sk--s"></div><div class="wj-qv__sk wj-qv__sk--p"></div>'
      + '<div class="wj-qv__sk wj-qv__sk--s"></div><div class="wj-qv__sk wj-qv__sk--g"></div>'
      + '<div class="wj-qv__sk wj-qv__sk--s"></div><div class="wj-qv__sk wj-qv__sk--g"></div></div>'
      + '<div class="wj-qv__foot"><div class="wj-qv__sk wj-qv__sk--q"></div><div class="wj-qv__sk wj-qv__sk--b"></div></div>'
      + '</div>';
  }

  function build() {
    if (shell) return;
    shell = document.createElement('div');
    shell.className = 'wj-qa';
    shell.setAttribute('aria-hidden', 'true');
    shell.innerHTML = '<div class="wj-qa__bd" data-wj-qa-bd></div>'
      + '<div class="wj-qa__panel" role="dialog" aria-modal="true" aria-label="Quick add" tabindex="-1" data-wj-qa-panel>'
      + '<span class="wj-qa__grip" aria-hidden="true"></span>'
      + '<button type="button" class="wj-qa__x" data-wj-qa-x aria-label="Close quick add">'
      + '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3 3 13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
      + '</button>'
      + '<div class="wj-qa__body" data-wj-qa-body></div>'
      + '</div>';
    document.body.appendChild(shell);
    panel = shell.querySelector('[data-wj-qa-panel]');
    body = shell.querySelector('[data-wj-qa-body]');
    shell.querySelector('[data-wj-qa-bd]').addEventListener('click', function () { close(); });
    shell.querySelector('[data-wj-qa-x]').addEventListener('click', function () { close(); });
    body.addEventListener('click', onBodyClick);
    panel.addEventListener('keydown', onPanelKey);
  }

  function lock() {
    if (document.body.classList.contains('wj-qa-lock')) return;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    bodyPad = document.body.style.paddingRight;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.documentElement.style.setProperty('--wj-qa-sbw', sbw + 'px');
    document.body.classList.add('wj-qa-lock');
  }
  function unlock() {
    document.body.classList.remove('wj-qa-lock');
    document.body.style.paddingRight = bodyPad || '';
    document.documentElement.style.removeProperty('--wj-qa-sbw');
  }

  /* ------------------------------------------------------------ open / close */
  function open(url, trig) {
    if (!url) return;
    build();
    var key = normalize(url);
    if (isOpen && !closing && key === currentKey) return;
    trigger = trig || ((document.activeElement && document.activeElement !== document.body) ? document.activeElement : null);
    currentKey = key;
    ctx = null;
    var html = cache[key];
    body.innerHTML = html || skeleton();
    if (!isOpen || closing) {
      closing = false;
      lock();
      shell.setAttribute('aria-hidden', 'false');
      shell.classList.add('is-open');
      shell.getBoundingClientRect();
      shell.classList.add('is-in');
      isOpen = true;
    }
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    if (html) { arm(true); return; }
    fetch(withView(key), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (txt) {
        if (!isFragment(txt)) throw new Error('no fragment');
        cache[key] = txt;
        if (isOpen && currentKey === key) { body.innerHTML = txt; arm(false); }
      })
      .catch(function () {
        /* the button is never dead: fall through to the PDP */
        if (isOpen && currentKey === key) close(function () { window.location.href = key; });
      });
  }

  function close(after, opts) {
    opts = opts || {};
    if (!isOpen || closing) { if (after) after(); return; }
    closing = true;
    if (ctx) clearTimeout(ctx.statusT);
    shell.classList.remove('is-in');
    var done = function () {
      if (!closing) return;
      shell.classList.remove('is-open');
      shell.setAttribute('aria-hidden', 'true');
      panel.removeAttribute('aria-labelledby');
      body.innerHTML = '';
      ctx = null;
      isOpen = false;
      closing = false;
      currentKey = '';
      unlock();
      if (!opts.keepFocus && trigger && document.contains(trigger)) {
        try { trigger.focus({ preventScroll: true }); } catch (e) { trigger.focus(); }
      }
      if (after) after();
    };
    setTimeout(done, reduced() ? 0 : EXIT_MS);
  }

  /* ------------------------------------------------------------ fragment */
  function arm(cached) {
    var root = body.querySelector('[data-wj-qv]');
    var jsonEl = root && root.querySelector('[data-wj-qv-json]');
    var data = null;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { data = null; }
    if (!root || !data || !data.variants) {
      close(function () { window.location.href = currentKey; });
      return;
    }
    var q = function (s) { return root.querySelector(s); };
    ctx = {
      data: data,
      root: root,
      sel: (data.options || []).map(function (o) { return o.values.length > 1 ? null : o.values[0]; }),
      qty: 1,
      slide: 0,
      busy: false,
      res: null,
      statusT: 0,
      nudgeT: 0,
      els: {
        from: q('[data-wj-qv-from]'), now: q('[data-wj-qv-now]'), was: q('[data-wj-qv-was]'), save: q('[data-wj-qv-save]'),
        vals: Array.prototype.slice.call(root.querySelectorAll('[data-wj-qv-val]')),
        sels: Array.prototype.slice.call(root.querySelectorAll('[data-wj-qv-sel]')),
        qn: q('[data-wj-qv-qn]'), minus: q('[data-wj-qv-q="-1"]'), plus: q('[data-wj-qv-q="1"]'),
        atc: q('[data-wj-qv-atc]'), text: q('[data-wj-qv-atc-text]'), priceWrap: q('[data-wj-qv-atc-price]'),
        atcWas: q('[data-wj-qv-atc-was]'), atcNow: q('[data-wj-qv-atc-now]'), sub: q('[data-wj-qv-atc-sub]'),
        status: q('[data-wj-qv-status]'), statusWrap: q('[data-wj-qv-status-wrap]'),
        rail: q('[data-wj-qv-rail]'), dots: Array.prototype.slice.call(root.querySelectorAll('[data-wj-qv-dot]')),
        prev: q('[data-wj-qv-arr="-1"]'), next: q('[data-wj-qv-arr="1"]')
      }
    };
    /* contract 2: the size guide is W2's global dialog; hide the trigger when it is not on the page */
    var sg = q('[data-wj-qv-sg]');
    if (sg && !(window.wjSizeGuide && typeof window.wjSizeGuide.open === 'function')) sg.hidden = true;
    if (ctx.els.rail) {
      var t = 0, rail = ctx.els.rail;
      rail.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (!ctx || ctx.els.rail !== rail) return;
          var i = Math.round(rail.scrollLeft / (rail.clientWidth || 1));
          if (i !== ctx.slide) { ctx.slide = i; paintRail(); }
        }, 60);
      }, { passive: true });
    }
    panel.setAttribute('aria-labelledby', 'wjQvTitle');
    paint();
    if (!cached) root.getBoundingClientRect();
    root.classList.add('is-ready');
  }

  function paint(opts) {
    if (!ctx) return;
    opts = opts || {};
    var E = ctx.els, data = ctx.data;
    var r = resolve(data, ctx.sel, ctx.qty, cartUnits(), quoteFn());
    ctx.res = r;
    if (r.clamped) status('Only ' + r.qty + ' available right now.', 4000);
    ctx.qty = r.qty;

    (data.options || []).forEach(function (o, oi) {
      var s = E.sels[oi];
      if (!s) return;
      var v = ctx.sel[oi];
      s.textContent = v == null ? 'Select' : v;
      s.classList.toggle('is-empty', v == null);
    });
    E.vals.forEach(function (b) {
      var oi = parseInt(b.getAttribute('data-wj-qv-oi'), 10);
      var val = b.getAttribute('data-wj-qv-val');
      var o = data.options[oi];
      var st = (o && r.values[oi]) ? r.values[oi][o.values.indexOf(val)] : 'ok';
      b.setAttribute('aria-pressed', ctx.sel[oi] === val ? 'true' : 'false');
      b.classList.toggle('is-off', st !== 'ok');
    });

    if (E.from) E.from.hidden = !r.from;
    if (E.now) E.now.textContent = money(r.price, data);
    if (E.was) { E.was.hidden = !(r.compare > r.price); E.was.textContent = r.compare > r.price ? money(r.compare, data) : ''; }
    if (E.save) { E.save.hidden = !(r.save > 0); E.save.textContent = 'Save ' + r.save + '%'; }

    if (E.qn && E.qn.textContent !== String(r.qty)) E.qn.textContent = r.qty;
    if (E.minus) E.minus.disabled = r.qty <= 1;
    if (E.plus) { if (r.qty >= r.max) E.plus.setAttribute('aria-disabled', 'true'); else E.plus.removeAttribute('aria-disabled'); }

    var atc = E.atc;
    if (atc && !ctx.busy) {
      atc.classList.remove('is-busy', 'is-added');
      var ready = r.state === 'ready';
      if (r.state === 'pending') E.text.textContent = selectLabel(r.pending[0]);
      else if (ready) E.text.textContent = 'Add to cart';
      else E.text.textContent = r.state === 'soldout' ? 'Sold out' : 'Unavailable';
      /* line 1 price (W2 markup): "Add to cart · ~~strike~~ pay"; in 'shift' mode the struck sell price sits under
         the real cart increase and the note below says why */
      var showWas = ready && r.mode !== 'shift' && r.totalStrike > 0 && r.totalStrike !== r.total; /* WAVY-JADE-0926: no strike in shift mode */
      E.priceWrap.hidden = !ready;
      E.atcWas.hidden = !showWas;
      E.atcWas.textContent = showWas ? money(r.totalStrike, data) : '';
      E.atcNow.textContent = ready ? money(r.total, data) : '';
      E.sub.hidden = !ready;
      if (r.mode === 'shift') {
        ctx.shiftNote = true;
        status('This piece takes the 50% off from your pair, so your total rises by ' + money(r.total, data) + '.');
      } else if (ctx.shiftNote) {
        ctx.shiftNote = false;
        status('');
      }
      if (r.state === 'pending') { atc.disabled = false; atc.setAttribute('aria-disabled', 'true'); }
      else if (ready) { atc.disabled = false; atc.removeAttribute('aria-disabled'); }
      else { atc.removeAttribute('aria-disabled'); atc.disabled = true; }
    }

    /* the rail follows the variant image on a pick (Dawn behaviour), never on a quantity tap */
    if (opts.image && r.image >= 0 && r.image < (data.images || 0) && r.image !== ctx.slide && E.rail) goTo(r.image);
  }

  function paintRail() {
    if (!ctx) return;
    var E = ctx.els, n = ctx.data.images || 1;
    E.dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === ctx.slide);
      if (i === ctx.slide) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
    if (E.prev) E.prev.setAttribute('aria-disabled', ctx.slide <= 0 ? 'true' : 'false');
    if (E.next) E.next.setAttribute('aria-disabled', ctx.slide >= n - 1 ? 'true' : 'false');
  }

  function goTo(i) {
    if (!ctx || !ctx.els.rail) return;
    var rail = ctx.els.rail, n = ctx.data.images || 1;
    i = Math.max(0, Math.min(n - 1, i));
    ctx.slide = i;
    paintRail();
    try { rail.scrollTo({ left: i * rail.clientWidth, behavior: reduced() ? 'auto' : 'smooth' }); }
    catch (e) { rail.scrollLeft = i * rail.clientWidth; }
  }

  function status(msg, ttl) {
    if (!ctx || !ctx.els.status) return;
    var s = ctx.els.status, w = ctx.els.statusWrap;
    clearTimeout(ctx.statusT);
    if (!msg) {
      w.classList.remove('is-on');
      ctx.statusT = setTimeout(function () { if (!w.classList.contains('is-on')) s.textContent = ''; }, 320);
      return;
    }
    s.textContent = msg;
    w.classList.add('is-on');
    if (ttl) ctx.statusT = setTimeout(function () { status(''); }, ttl);
  }

  function nudge(name) {
    var oi = -1;
    ctx.data.options.some(function (o, i) { if (o.name === name) { oi = i; return true; } return false; });
    var opt = ctx.root.querySelector('[data-wj-qv-opt="' + oi + '"]');
    if (!opt) return;
    opt.classList.remove('is-nudge');
    opt.getBoundingClientRect();
    opt.classList.add('is-nudge');
    clearTimeout(ctx.nudgeT);
    ctx.nudgeT = setTimeout(function () { opt.classList.remove('is-nudge'); }, 1400);
    var first = opt.querySelector('[data-wj-qv-val]');
    if (first) {
      try { opt.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { /* ignore */ }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    status(selectLabel(name) + ' to continue.', 3000);
  }

  function setQty(n, dir) {
    if (!ctx || n === ctx.qty) return;
    ctx.qty = n;
    var qn = ctx.els.qn;
    if (qn) {
      qn.textContent = n;
      qn.classList.remove('is-up', 'is-down');
      qn.getBoundingClientRect();
      qn.classList.add(dir > 0 ? 'is-up' : 'is-down');
    }
    paint();
  }

  function step(dir) {
    if (!ctx || ctx.busy) return;
    var r = ctx.res || resolve(ctx.data, ctx.sel, ctx.qty, cartUnits(), quoteFn());
    var next = ctx.qty + dir;
    if (next < 1) return;
    if (next > r.max) {
      status(r.stockCapped ? "That's all the stock we have." : 'Up to ' + MAX_QTY + ' at a time.', 4000);
      return;
    }
    status('');
    setQty(next, dir);
  }

  /* ------------------------------------------------------------ add */
  function add() {
    if (!ctx || ctx.busy) return;
    var r = ctx.res || resolve(ctx.data, ctx.sel, ctx.qty, cartUnits(), quoteFn());
    if (r.state === 'pending') { nudge(r.pending[0]); return; }
    if (r.state !== 'ready') return;
    var atc = ctx.els.atc;
    ctx.busy = true;
    status('');
    atc.classList.add('is-busy');
    atc.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var url = /\.js$/.test(base) ? base : base + '.js';
    var payload = {
      items: [{ id: r.variant.id, quantity: r.qty }],
      sections: sections.join(','),
      sections_url: window.location.pathname
    };
    var frag = ctx;
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (j) { return { ok: res.ok, json: j || {} }; }, function () { return { ok: false, json: {} }; });
      })
      .then(function (out) {
        var j = out.json;
        if (!out.ok || j.status) throw new Error(j.description || j.message || '');
        /* the modal may have been closed mid-request: the item is in the cart, so the drawer still renders
           (handoff guards its own render and falls back to the cart page) */
        if (ctx !== frag) { handoff(j, r, drawer, frag.data, trigger); return; }
        onAdded(j, r, drawer);
      })
      .catch(function (err) {
        if (ctx !== frag) return;
        ctx.busy = false;
        atc.classList.remove('is-busy');
        atc.removeAttribute('aria-busy');
        status((err && err.message) || "Couldn't add this piece. Please try again.");
      });
  }

  /* Same handoff as product-form.js: is-empty off, cartUpdate published, drawer re-rendered from `sections`. */
  function handoff(json, r, drawer, data, trig) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'wj_quick_add', product_handle: data.handle, variant_id: r.variant.id, quantity: r.qty, value: r.total / 100, currency: data.currency || '' });
    } catch (e) { /* ignore */ }
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var detail = { handle: data.handle, variantId: r.variant.id, quantity: r.qty, response: json };
    var announce = function () {
      try { document.dispatchEvent(new CustomEvent('wj:qa-added', { bubbles: true, detail: detail })); } catch (e) { /* ignore */ }
    };
    if (!(drawer && json.sections && typeof drawer.renderContents === 'function')) {
      announce();
      window.location.href = cartUrl;
      return;
    }
    /* the add already succeeded: a publish/render failure goes to the cart page, never an error (wavy-bogo.js rule) */
    try {
      drawer.classList.remove('is-empty');
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trig);
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: r.variant.id });
      }
      drawer.renderContents(json);
    } catch (e) {
      announce();
      window.location.href = cartUrl;
      return;
    }
    announce();
  }

  function onAdded(json, r, drawer) {
    var atc = ctx.els.atc, data = ctx.data, trig = trigger;
    atc.classList.remove('is-busy');
    atc.removeAttribute('aria-busy');
    atc.classList.add('is-added');
    /* the tick shows for a beat, then the modal exits and the drawer takes over (it owns focus from here) */
    setTimeout(function () {
      close(function () { handoff(json, r, drawer, data, trig); }, { keepFocus: true });
    }, reduced() ? 0 : 420);
  }

  /* ------------------------------------------------------------ events */
  function onBodyClick(e) {
    var t = e.target;
    if (!ctx || !t.closest) return;
    var val = t.closest('[data-wj-qv-val]');
    if (val) {
      if (ctx.busy) return;
      var oi = parseInt(val.getAttribute('data-wj-qv-oi'), 10);
      ctx.sel[oi] = val.getAttribute('data-wj-qv-val');
      var opt = val.closest('[data-wj-qv-opt]');
      if (opt) opt.classList.remove('is-nudge');
      status('');
      paint({ image: true });
      return;
    }
    var qb = t.closest('[data-wj-qv-q]');
    if (qb) { step(parseInt(qb.getAttribute('data-wj-qv-q'), 10)); return; }
    if (t.closest('[data-wj-qv-atc]')) { add(); return; }
    var sg = t.closest('[data-wj-qv-sg]');
    if (sg) {
      if (e.defaultPrevented || !(window.wjSizeGuide && typeof window.wjSizeGuide.open === 'function')) return;
      e.preventDefault();
      var widths = String(sg.getAttribute('data-wj-sg-widths') || '').split(',')
        .map(function (w) { return parseInt(w, 10); })
        .filter(function (w) { return !isNaN(w); });
      window.wjSizeGuide.open({ type: sg.getAttribute('data-wj-sg-type') || 'bracelet', widths: widths, opener: sg });
      return;
    }
    var more = t.closest('[data-wj-qv-more]');
    if (more) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var href = more.getAttribute('href');
      close(function () { window.location.href = href; });
      return;
    }
    var dot = t.closest('[data-wj-qv-dot]');
    if (dot) { goTo(parseInt(dot.getAttribute('data-wj-qv-dot'), 10)); return; }
    var arr = t.closest('[data-wj-qv-arr]');
    if (arr && arr.getAttribute('aria-disabled') !== 'true') goTo(ctx.slide + parseInt(arr.getAttribute('data-wj-qv-arr'), 10));
  }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'),
      function (el) { return !el.hidden && !el.closest('[hidden]') && el.getClientRects().length > 0; }
    );
  }

  function onPanelKey(e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      if (ctx && e.target === ctx.els.rail) { e.preventDefault(); goTo(ctx.slide + (e.key === 'ArrowRight' ? 1 : -1)); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (e.shiftKey && (cur === first || cur === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isOpen || closing || e.defaultPrevented) return;
    /* the size guide (a native <dialog>, contract 2) handles its own Escape first */
    if (e.target && e.target.closest && e.target.closest('dialog')) return;
    if (document.querySelector('dialog[open]')) return;
    e.preventDefault();
    close();
  });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-wj-qa]') : null;
    if (!t) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url = t.getAttribute('data-wj-qa') || t.getAttribute('href');
    if (!url) return;
    e.preventDefault();
    open(url, t);
  });

  /* hover intent prefetch (mouse only; touch taps must not double-fetch): the fragment is cached before the click */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = e.target && e.target.closest ? e.target.closest('[data-wj-qa]') : null;
    if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
    var url = t.getAttribute('data-wj-qa') || t.getAttribute('href');
    if (!url) return;
    var key = normalize(url);
    if (cache[key] || prefetching[key]) return;
    prefetching[key] = setTimeout(function () {
      prefetching[key] = 'inflight';
      fetch(withView(key), { credentials: 'same-origin', priority: 'low' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) { if (isFragment(txt)) cache[key] = txt; delete prefetching[key]; })
        .catch(function () { delete prefetching[key]; });
    }, 150);
  }, { passive: true });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = e.target && e.target.closest ? e.target.closest('[data-wj-qa]') : null;
    if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
    var key = normalize(t.getAttribute('data-wj-qa') || t.getAttribute('href') || '');
    if (typeof prefetching[key] === 'number') { clearTimeout(prefetching[key]); delete prefetching[key]; }
  }, { passive: true });

  window.wjQuickAdd = {
    open: open,
    close: function () { close(); },
    core: { resolve: resolve, formatMoney: formatMoney, selectLabel: selectLabel, optionLabel: optionLabel, savePct: savePct, MAX_QTY: MAX_QTY }
  };
})();
